var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChequeReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2834 2.66699H29.7162C31.7392 2.66699 33.3635 4.5286 33.3329 6.81171L33.333 31.8556C33.333 34.1387 31.7085 36.0003 29.7162 36.0003H10.2834C8.29118 36.0003 6.66663 34.1387 6.66663 31.8556V6.81171C6.66663 4.52866 8.29113 2.66699 10.2834 2.66699ZM11.9692 29.9238H28.0304C28.4595 29.9238 28.8272 29.5023 28.8272 29.0105C28.8272 28.5188 28.4595 28.0973 28.0304 28.0973H11.9692C11.5401 28.0973 11.1723 28.5188 11.1723 29.0105C11.1723 29.5023 11.5401 29.9238 11.9692 29.9238ZM11.9692 23.4959H28.0304C28.4595 23.4959 28.8272 23.0744 28.8272 22.5827C28.8272 22.0909 28.4595 21.6695 28.0304 21.6695H11.9692C11.5401 21.6695 11.1723 22.0909 11.1723 22.5827C11.1723 23.0745 11.5401 23.4959 11.9692 23.4959ZM22.2986 17.033H28.0304C28.4595 17.033 28.8273 16.6466 28.7966 16.1198C28.7966 15.628 28.4288 15.2066 27.9997 15.2066H22.2986C21.8695 15.2066 21.5017 15.628 21.5017 16.1198C21.5017 16.6116 21.8695 17.033 22.2986 17.033ZM22.2986 10.6052H28.0304C28.4595 10.6052 28.7966 10.1837 28.7966 9.69196C28.7966 9.20018 28.4288 8.77875 27.9997 8.77875H22.2986C21.8695 8.77875 21.5017 9.20018 21.5017 9.69196C21.5017 10.1837 21.8695 10.6052 22.2986 10.6052ZM14.922 10.5828H16.1852L16.1727 10.5828V9.67331H11.8148V10.6333L13.179 10.6332C13.6716 10.6332 14.0885 10.9238 14.2653 11.3532H11.8148V12.2627H14.2653C14.0885 12.6796 13.6716 12.9828 13.179 12.9828H11.8148V14.1449L14.0253 16.3807L15.3642 16.3806L12.9642 13.9427H13.179C14.2021 13.9427 15.061 13.2227 15.2631 12.2627L16.1852 12.2628V11.3533H15.2631C15.1999 11.0754 15.0863 10.8101 14.922 10.5828Z",
    fill: "url(#paint0_linear_1743_14360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1743_14360",
    x1: 6.66663,
    y1: 19.3337,
    x2: 33.3333,
    y2: 19.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeReceipts);
export default __webpack_public_path__ + "static/media/ChequeReceipts.3d8938546827081bec6c13fb1e36212b.svg";
export { ForwardRef as ReactComponent };